/**
 * Texto de gente na tela: comparar sem acento, frase em vez de grito, nome
 * próprio em vez de caixa alta. Puro, para o teste não precisar de janela.
 */

/** Para comparar etiqueta e tese: "Reconhecimento de Vínculo" e "RECONHECIMENTO DE VINCULO" são a mesma coisa. */
export const semAcento = (t) =>
  String(t)
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .trim();

/** "RECONHECIMENTO DE VÍNCULO" → "Reconhecimento de vínculo": a planilha grita, a linha fala. */
export const comoFrase = (t) => {
  const s = String(t).trim().toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
};

/* Nome que a planilha trouxe em caixa alta se lê como nome próprio. Só na
   EXIBIÇÃO e só quando está todo em maiúsculas: nome que alguém escreveu com
   caixa mista ("McDonald", "da Silva") é dado de gente e não se reescreve. */
const MINUSCULAS = new Set(["da", "de", "do", "das", "dos", "e"]);
export const comoNome = (nome) => {
  const n = String(nome ?? "").trim();
  if (!n || n !== n.toUpperCase() || n === n.toLowerCase()) return n;
  return n
    .toLowerCase()
    .split(/\s+/)
    .map((p, i) => (i > 0 && MINUSCULAS.has(p) ? p : p.charAt(0).toUpperCase() + p.slice(1)))
    .join(" ");
};

/* A função da pessoa chega como CHAVE (`socio`, `juridico`): a caixa de quem
   cuida imprimia "socio" em minúscula e sem acento embaixo do nome.
   ponytail: espelho do rótulo de `FUNCOES` em src/core.ts (que importa o banco e
   não entra na tela); função nova lá cai no `comoFrase` até ganhar linha aqui. */
const ROTULO_DA_FUNCAO = {
  comercial: "Comercial",
  atendimento: "Atendimento",
  juridico: "Jurídico",
  advogado: "Advogado",
  socio: "Sócio",
  financeiro: "Financeiro",
};
export const rotuloDaFuncao = (chave) => (chave ? (ROTULO_DA_FUNCAO[chave] ?? comoFrase(chave)) : "");

